import setWith from 'lodash/setWith';

const initialState = {
	'loading': false,
	'noop': { // allows routes to point store to here and render without actually making requests
		'success': {status: 'success'},
	},
};

const fetcherReducer = (state=initialState, action) => {
	switch (action.type) {
		case 'FETCH_JSON_BEGIN':
			{
				const cloned = { ...state, loading: false }
				setWith( cloned, (action.payload.drawer || action.payload.dir), { status: "fetching" }, Object);
				return cloned;
			}

		case 'FETCH_JSON_SUCCESS':
			{
				const cloned = { ...state, loading: false } // (shallow-)clone [state.results]
				const result = { status: "success", data: action.payload.data };
				setWith( cloned, (action.payload.drawer || action.payload.dir), result, Object );
				return cloned;
			}

		case 'FETCH_JSON_FAILURE':
			{
				console.log('FETCH_JSON_FAILURE', action);
				const cloned = { ...state, loading: false }
				setWith( cloned, (action.payload.drawer || action.payload.dir), { status: "error" }, Object );
				return cloned;
			}

		default:
			return state;
	}
}

export default fetcherReducer;


// WEBPACK FOOTER //
// ./src/reducers/fetcher.jsx